import { render, staticRenderFns } from "./RoleStatusesPanel.vue?vue&type=template&id=bf635132&"
import script from "./RoleStatusesPanel.vue?vue&type=script&lang=js&"
export * from "./RoleStatusesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports